if (import.meta.env.DEV) {
  import("react-grab");
}

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { HomePage } from "./components/HomePage";
import { LegalPage, isLegalPage } from "./components/LegalPage";
import { resolveCreateRoomRedirect } from "./config";
import "./styles.css";

function bootstrap(): void {
  const root = document.getElementById("root");
  if (!root) throw new Error("Root element #root not found");

  const path = window.location.pathname.replace(/\/$/, "") || "/";
  const Page =
    path === "/home" ? HomePage : isLegalPage(path) ? LegalPage : App;

  createRoot(root).render(
    <StrictMode>
      <Page />
    </StrictMode>,
  );
}

// `?create` → rewrite to a fresh `?room=<code>` before the app mounts.
if (!resolveCreateRoomRedirect()) {
  bootstrap();
}
